import { useEffect, useRef } from 'preact/hooks';

/**
 * This hook is used to run an effect only when the component is updated. Ignore the first render.
 * @param onUpdate
 * @param inputs
 */
export function useUpdateEffect(onUpdate: VoidFunction, inputs: unknown[]) {
  const isMounted = useRef(true);

  useEffect(() => {
    const isFirstMount = isMounted.current;
    isMounted.current = false;

    // Ignore the first render.
    if (isFirstMount) return;

    // Run the effect for updates.
    return onUpdate();
  }, inputs);
}
